import Option from "./Option.js"
import Option2 from "./Option2.js"
import { v1 as UUID } from "uuid";

// 问题类
let Question = function () {
    this.qid = 0; // 试题id
    this.questionsTypeId = ""; // 试题类型
    this.questionsName = ""; // 试题名称
    this.inputHeight = '小' // 输入框高度(填空、简答)
    this.mustanswer = true; //是否必填
    this.showcolnum = 1; //显示列数
    this.minNum = 0 // 最小限制字数
    this.maxNum = 0 // 最大限制字数
    this.decimalPlaces = 0 // 保留小数位数
    this.isHideTitle = false // 是否隐藏该题
    this.isHideScore = false // 答案与分值
    this.scoringType = 1 // 计分方式
    this.answer = ""; //选择的结果
    this.partialScore = 0 // 少选可得分（多选）、每答出一个关键词 （简答）
    this.scoreArr = [] // 每个选项都有对应分值模式下 (前端使用)
    this.oidScoreArr = []  // 每个选项都有对应分值模式下 (拼接了选项id)
    this.isedit = false; //是否编辑问题
    this.analysis = '' // 答案解析
    this.optionList = new Array();
    this.createDefaultOption = function() {
        switch (this.questionsTypeId) {
            case 100:
            case 101:
            case 102:{
                for (var i = 0; i < 2; i++) {
                    let option = new Option("选项" + (i + 1))
                    if (i == 0) {
                        this.answer = option.oid
                    }
                    this.optionList.push(option)
                }  
                break;
            }
            case 206:
                this.scoringType = 4
                this.matchingType = 3 // 匹配评分方式：回答关键词类型（简答）、回答项类型（多项填空）
                break
            case 207:
                this.matchingType = 1 // 匹配评分方式：回答关键词类型（简答）、回答项类型（多项填空）
                for (var i = 0; i < 2; i++) {
                    let option = new Option2('填空' + (i + 1))
                    this.optionList.push(option)
                }
                break;
            case 209:
                this.scoringType = 3
                break;
            case 210:
            // case 211:
                this.scoringType = 3
                this.maxfilesNum = 10 // 最多上传文件数量
                this.fileSize = 30 // 单个上传文件大小(MB)
                this.limitFormat = '' // 文件限制格式
                break
        }
    }
}

export default Question;